import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as engagementCharterComponent from '../engagement-charter-component'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: engagementCharterComponent.RESOURCE.payload.dimension.partialId,
      partialId: engagementCharterComponent.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Who recorded this engagement charter component.',
    isOptional: false,
    name: 'Actor',
    partialId: PartialId.Standard.create('actor'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
